import { ResponseResolver, restContext, RestRequest } from 'msw';
import { delayedResponse } from '@/utils/useMswCustomResponse';
import { PersonalApplicantResponse } from '../types/applicant';

/**
 * 申込者情報を更新する
 */
const putApplicant: ResponseResolver<RestRequest, typeof restContext> = async (
  req,
  res,
  ctx,
) => {
  const applicationId = Number(req.params.applicationId);
  return delayedResponse(ctx.status(204));
};

/**
 * 個人申込者情報のベースモックデータ
 * E2Eテストなどで再利用可能
 */
export const basePersonalApplicantResponse: PersonalApplicantResponse = {
  monthlyApplicationId: 110,
  parkingId: 451265,
  parkingName: '決済テスト用駐車場（モック1）',
  parkingAddress: '静岡県藤本市松本町',
  lastName: '後藤',
  firstName: '達也',
  lastNameKana: 'ゴトウ',
  firstNameKana: 'タツヤ',
  email: 't.goto+100@sonicmoov.com',
  gender: 'MAN',
  genderMapping: [
    {
      enum: 'MAN',
      label: '男',
    },
    {
      enum: 'WOMAN',
      label: '女',
    },
  ],
  birthday: '1904-10-09T00:00:00+09:00',
  zipCode: '1000001',
  addressRegion: '東京都千代田区千代田',
  addressDetail: 'テスト',
  landlinePhoneNumber: ['03', '1234', '5678'],
  mobilePhoneNumber: null,
  jobType: 'UNEMPLOYED',
  jobTypeMapping: [
    {
      enum: 'COMPANY_OFFICER',
      label: '会社役員',
    },
    {
      enum: 'COMPANY_EMPLOYEE',
      label: '会社員',
    },
    {
      enum: 'SELF_EMPLOY',
      label: '自営業',
    },
    {
      enum: 'PART_TIME_JOB',
      label: 'パート・アルバイト',
    },
    {
      enum: 'STUDENT',
      label: '学生',
    },
    {
      enum: 'HOMEWORKER_OTHER',
      label: '家事従事者/その他',
    },
  ],
  workplaceCompanyName: null,
  workplaceCompanyNameKana: null,
  workplaceZipCode: null,
  workplaceAddressRegion: null,
  workplaceAddressDetail: null,
  workplacePhoneNumber: null,
  workplaceIndustryCategory: null,
  workplaceIndustryCategoryMapping: [
    {
      enum: 'CONSTRUCTION',
      label: '建設業',
    },
    {
      enum: 'MANUFACTURING',
      label: '製造業',
    },
    {
      enum: 'ELECTRICITY_GAS',
      label: '電気・ガス',
    },
    {
      enum: 'TRANSPORTATION_COMMUNICATION',
      label: '運輸・通信業',
    },
    {
      enum: 'WHOLESALE_RETAIL_FOOD',
      label: '卸売・小売・飲食業',
    },
    {
      enum: 'FINANCE_INSURANCE',
      label: '金融・保険業',
    },
    {
      enum: 'REAL_ESTATE',
      label: '不動産業',
    },
    {
      enum: 'SERVICE',
      label: 'サービス業',
    },
    {
      enum: 'EDUCATION',
      label: '教育',
    },
    {
      enum: 'AGRICULTURE_FORESTRY_FISHERY',
      label: '農林水産業',
    },
    {
      enum: 'OTHER',
      label: 'その他',
    },
  ],
  annualIncome: 500,
  householdIncome: null,
  emergencyContactLastName: 'あ',
  emergencyContactFirstName: 'あ',
  emergencyContactLastNameKana: 'ア',
  emergencyContactFirstNameKana: 'ア',
  emergencyContactPhoneNumber: ['080', '1234', '5678'],
  emergencyContactRelationship: 'テスト',
  usagePurpose: 'PERSONAL',
  usagePurposeMapping: [
    {
      enum: 'PERSONAL',
      label: '個人利用',
    },
    {
      enum: 'CORPORATION',
      label: '法人利用',
    },
  ],
  vehicleOwnershipStatus: 'CONTRACT_VEHICLE_DECIDED',
  vehicleOwnershipStatusMapping: [
    {
      enum: 'CONTRACT_VEHICLE_DECIDED',
      label: '契約車両が決定している',
    },
    {
      enum: 'CONTRACT_VEHICLE_UNOWNED',
      label: '契約車両未保有（納車前など）',
    },
  ],
  parkedVehicleType: 'セダン',
  parkedVehicleColor: '白',
  scheduledDeliveryDate: null,
  noVehicleReason: 'テスト',
  frontVehicleImageUrl: 'https://picsum.photos/700/500',
  backVehicleImageUrl: 'https://picsum.photos/700/500',
  sideVehicleImageUrl: 'https://picsum.photos/700/500',
  frontLicenseImageUrl: 'https://picsum.photos/700/500',
  backLicenseImageUrl: 'https://picsum.photos/700/500',
  carInspectionImageUrl: null,
  parkedVehicleCategory: 'NOT_SPECIFIED',
  bikeDisplacement: 'UNDER_125CC',
  vehicleNumber: {
    localName: '品川',
    classificationNumber: '123',
    hiragana: 'あ',
    serialNumber: '12-34',
  },
};

/**
 * 申込者情報取得ハンドラーを生成する
 * @param override レスポンスを上書きする（テストで使用）
 */
export const createGetApplicant = (
  override?: Partial<PersonalApplicantResponse>,
): ResponseResolver<RestRequest, typeof restContext> => {
  return async (_req, _res, ctx) => {
    return delayedResponse(
      ctx.status(200),
      ctx.json<PersonalApplicantResponse>({
        ...basePersonalApplicantResponse,
        ...override,
      }),
    );
  };
};

const mockApplicant = {
  getApplicant: createGetApplicant(),
  putApplicant,
};

export default mockApplicant;
